module.exports = __webpack_public_path__ + "static/media/sequipament.f2fb224b.svg";